module.exports = __webpack_public_path__ + "static/media/ES.f61eca15.svg";